import { pwaUpdateService } from "./PwaUpdateService.js";
//#region src/pwa/PwaUpdateController.ts
var PwaUpdateController = class {
	constructor(host) {
		this._host = host;
		host.addController(this);
	}
	/** True when a new version is installed and waiting to take over. */
	get updateAvailable() {
		return pwaUpdateService.updateAvailable;
	}
	/** True between `apply()` and the reload it triggers. */
	get applying() {
		return pwaUpdateService.applying;
	}
	/**
	* Activate the waiting worker; the page reloads once it has taken over.
	* @returns `false` when there is nothing to apply.
	*/
	apply() {
		return pwaUpdateService.applyUpdate();
	}
	/** Ask the browser to check for a new service worker now. */
	check() {
		return pwaUpdateService.checkForUpdate();
	}
	hostConnected() {
		this._unsubscribe = pwaUpdateService.subscribe(() => {
			this._host.requestUpdate();
		});
	}
	hostDisconnected() {
		this._unsubscribe?.();
	}
};
//#endregion
export { PwaUpdateController };
